import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appDecimalFormatValidator]'
})
export class DecimalFormatValidatorDirective {

  private regex: RegExp = new RegExp(/^\d*\.?\d{0,3}$/g);
  private negativeRegex: RegExp = new RegExp(/^[-]?\d*\.?\d{0,3}$/g);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'Delete', 'ArrowLeft', 'ArrowRight'];
  @Input() allowNegativeValue: boolean;
  @Input() maxValue: number;

  constructor(
    private elementRef: ElementRef
  ) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {

    // Allow Backspace, tab, end, and home, delete, ArrowLeft, ArrowRight keys
    if (this.specialKeys.indexOf(event.key) !== -1 && (this.maxValue == null || (event.key != 'Delete' && event.key != 'Backspace'))) {
      return;
    }

    let next = '';
    const element = this.elementRef.nativeElement;
    const current = element.value;
    let selectionStart: number = element.selectionStart != null ? element.selectionStart : 0;
    let selectionEnd: number = element.selectionEnd != null ? element.selectionEnd : 0;
    const eventKeyValue = event.key != 'Delete' && event.key != 'Backspace' ? event.key : '';

    if (selectionStart == selectionEnd) {
      if (event.key == 'Delete' && selectionStart != current.length - 1) {
        selectionEnd = selectionEnd + 1;
      }
      else if (event.key == 'Backspace' && selectionStart != 0) {
        selectionStart = selectionStart - 1;
      }
    }

    if (selectionStart != selectionEnd) {
      next = current.replace(current.substring(selectionStart, selectionEnd), eventKeyValue);
    }
    else if (selectionStart == 0) {
      next = eventKeyValue.concat(current);
    }
    else if (selectionStart != current.length - 1) {
      next = current.substring(0, selectionStart) + eventKeyValue + current.substring(selectionStart);
    }
    else {
      next = current.concat(eventKeyValue);
    }

    if (this.allowNegativeValue == true) {
      if (next && !String(next).match(this.negativeRegex)) {
        event.preventDefault();
      }
    }
    else {
      if (next && !String(next).match(this.regex)) {
        event.preventDefault();
      }
      else if (this.maxValue != null && parseFloat(next) > this.maxValue) {
        event.preventDefault();
      }
    }
  }
}
